module.exports = __webpack_public_path__ + "img/mr_natas.8f74d190.jpg";